import MsgCard from './index.vue';
export default MsgCard;
